import { Component, computed, input } from '@angular/core';
import { cva } from 'class-variance-authority';

import { ÉtatSéquence } from '../../../models/état-séquence.enum';
import { ConvertEtatSequenceToStringPipe } from '../../../pipes/convert-etat-séquence-to-string.pipe';

export const listVariants = cva('paragraph-medium-medium rounded-full px-4 py-2 text-center', {
  variants: {
    variant: {
      [ÉtatSéquence.A_FAIRE]: 'bg-feedback-warning-lightest',
      [ÉtatSéquence.EN_COURS]: 'bg-feedback-informative-lightest',
      [ÉtatSéquence.TERMINEE]: 'bg-feedback-positive-lightest',
      [ÉtatSéquence.DESACTIVEE]: 'bg-light',
    },
  },
});

@Component({
  selector: 'app-sequence-etat',
  imports: [ConvertEtatSequenceToStringPipe],
  templateUrl: './sequence-etat.component.html',
})
export class SequenceEtatComponent {
  readonly etat = input.required<ÉtatSéquence | undefined>();
  protected readonly etatSequence = ÉtatSéquence;

  protected readonly _computedClass = computed(() => listVariants({ variant: this.etat() }));
}
